module.exports = __webpack_public_path__ + "images/slab-serif-0d28975319cc9f1f1564008429e15473.jpg";